const awardWrappers=document.querySelectorAll('.award-with-modal');

for(let awardWrapper of awardWrappers){
    const toggle=awardWrapper.querySelector('.modal-toggle');
    const modal=awardWrapper.querySelector('.modal');
    if(!modal || !toggle) continue;

    toggle.addEventListener('click', (e)=>{
        e.preventDefault();

        document.body.style.overflow='hidden';
        modal.classList.add('active');
    })
}

